import { Form, Select } from "antd"
import { formItemLayoutBalanced } from "../../_components/SettingFormItems"
import * as React from "react"
import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"

type Props = {
    defaultLayoutTemplate: Maybe<number>
    onStateValueChanged: (stateKey: string, value: Maybe<any>) => void
    onChangeCallback: () => void
}
export const MibLayoutSelectRow = (props: Props) => {
    return (
        <Form.Item
            style={{
                marginBottom: "0rem",
                borderTop: "none",
            }}
            className="receipt-setting-form-item"
            {...formItemLayoutBalanced}
            label="Online Ordering Website Template">
            <Select
                defaultValue={props.defaultLayoutTemplate}
                value={props.defaultLayoutTemplate}
                onChange={value => {
                    props.onStateValueChanged("defaultLayoutTemplate", value || null)
                    props.onChangeCallback()
                }}
                style={{
                    width: "12rem",
                }}>
                <Select.Option value="standard">Standard</Select.Option>
                <Select.Option value="simple">Simple</Select.Option>
            </Select>
        </Form.Item>
    )
}
